import { ChangeEvent, useContext, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { Button, FormControl, Grid, Typography } from '@mui/material'
import { Form, Formik, FormikProps } from 'formik'
import { useSnackbar } from 'notistack'
import * as Yup from 'yup'

import Footer from '../../components/footer'
import FormikTextField from '../../components/formik-input'
import IntroContainer from '../../components/intro-container'
import SubmitContainer from '../../components/submit-container'
import { AuthenticationContext } from '../../providers/auth-provider'
import { saveDeviceIds } from '../../utils/helpers'
import useSharedStyles from '../../utils/shared.styles'

import EmailPasswordForm from './email-password-form'
import sendPasscode from './helpers'
import useStyles from './index.styles'

const Login = () => {
  const classes = useStyles
  const sharedClasses = useSharedStyles

  const navigate = useNavigate()
  const { state } = useLocation()
  const { enqueueSnackbar } = useSnackbar()
  const { setLogin } = useContext(AuthenticationContext)

  saveDeviceIds()

  const [showPasswordForm, setShowPasswordForm] = useState<boolean>(false)
  const [email, setEmail] = useState<string>('')

  const initialValues = {
    email,
  }

  const schema = Yup.object().shape({
    email: Yup.string().email('Please provide a valid email address').required('Email is required'),
  })

  const handleSubmit = async (values: ILoginFormValues) => {
    await sendPasscode(
      values,
      () => {
        setLogin(values.email)
        navigate('/passcode', { state })
      },
      enqueueSnackbar
    )
  }

  return (
    <>
      <Grid container={true} sx={classes.mainContentGrid}>
        <Grid>
          {!state?.alertAckData && !state?.alertAckResponse ? (
            <IntroContainer title="Let's make sure it's you" subtitle="Please provide your email address to log in to your account." />
          ) : (
            <IntroContainer title="Let's make sure it's you" subtitle="Please provide an email address to receive your verification code." />
          )}

          {!showPasswordForm && (
            <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={schema} validateOnMount={true} enableReinitialize>
              {({ isSubmitting, values }: FormikProps<ILoginFormValues>) => (
                <Form>
                  <Grid container={true}>
                    <Grid container={true} size={12} sx={classes.formFieldContainer}>
                      <FormControl sx={classes.formControl}>
                        <FormikTextField
                          name="email"
                          label="Email"
                          placeholder="Enter your email address"
                          className="fs-exclude"
                          sx={sharedClasses.input}
                          onChange={(e: ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                        />
                      </FormControl>
                    </Grid>

                    <SubmitContainer>
                      <Button type="submit" loading={isSubmitting} disabled={isSubmitting} variant="contained" sx={classes.loginFormSubmitButton}>
                        Get Verification Code
                      </Button>

                      <Typography variant="body2">OR</Typography>

                      <Button
                        type="button"
                        variant="text"
                        onClick={() => {
                          setEmail(values.email)
                          setShowPasswordForm(true)
                        }}
                      >
                        Use Password Instead
                      </Button>
                    </SubmitContainer>
                  </Grid>
                </Form>
              )}
            </Formik>
          )}

          {showPasswordForm && <EmailPasswordForm setShowPasswordForm={setShowPasswordForm} email={email} setEmail={setEmail} />}
        </Grid>
        <Grid size={12} sx={classes.loginFooterWrapper}>
          <Footer />
        </Grid>
      </Grid>
    </>
  )
}

export default Login
